<rma-blog-post-list
  [showPrimary]="isHome$ | async"
  [showMore]="displayShowMore$ | async"
  [posts]="posts$ | async"
  (loadMore)="loadMore()" />
